import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  margin-bottom: 6px;
`;

export const LeftColumn = styled.div`
  width: 120px;
  margin-right: 5px;
  position: relative;
`;
